import { Entry } from "contentful";
import { createContext, Dispatch, SetStateAction, useContext, useState } from "react";

import Eva from "~/services/eva";
import Editorials from "~/types/editorials";

const Context = createContext<
  | {
      category: Entry<Editorials.CategoryBinding>;
      sort: EVA.Core.SortFieldDescriptor[];
      setSort: Dispatch<SetStateAction<EVA.Core.SortFieldDescriptor[]>>;
    }
  | undefined
>(undefined);

export default function CategoryProvider(props: {
  category: Entry<Editorials.CategoryBinding>;
  children: React.ReactNode;
}) {
  const [sort, setSort] = useState(Eva.DEFAULT_CATEGORY_SORT);

  return <Context.Provider value={{ category: props.category, sort, setSort }}>{props.children}</Context.Provider>;
}

export function useCategory() {
  const context = useContext(Context);

  if (!context) {
    throw new Error(`useCategory must be used within a CategoryProvider`);
  }

  return context;
}
